var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandMetaStyleBrand = function SvgBrandMetaStyleBrand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0081FB",
    d: "M2.592 14.544c0 .916.201 1.62.464 2.046.345.557.86.793 1.383.793.676 0 1.295-.168 2.487-1.816.954-1.32 2.08-3.175 2.836-4.338l1.282-1.97c.89-1.368 1.922-2.888 3.104-3.92.964-.84 2.005-1.308 3.052-1.308 1.759 0 3.434 1.02 4.716 2.93C23.319 9.056 24 11.692 24 14.413c0 1.618-.319 2.806-.861 3.745-.524.908-1.546 1.815-3.264 1.815v-2.589c1.47 0 1.838-1.352 1.838-2.9 0-2.204-.514-4.651-1.646-6.4-.804-1.24-1.846-1.998-2.992-1.998-1.24 0-2.236.935-3.357 2.602-.596.885-1.208 1.964-1.895 3.182l-.756 1.34c-1.52 2.693-1.904 3.306-2.663 4.319-1.332 1.773-2.468 2.444-3.965 2.444-1.775 0-2.898-.768-3.593-1.927C.28 17.101 0 15.863 0 14.451z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMetaStyleBrand__paint0_linear_3952_112970)",
    d: "M2.044 7.144c1.189-1.832 2.904-3.113 4.87-3.113 1.14 0 2.273.337 3.455 1.303 1.294 1.056 2.673 2.794 4.393 5.66l.617 1.028c1.488 2.48 2.336 3.756 2.831 4.358.638.773 1.084 1.003 1.665 1.003 1.47 0 1.838-1.352 1.838-2.9l2.287-.07c0 1.617-.319 2.805-.861 3.744-.524.908-1.546 1.815-3.264 1.815-1.069 0-2.015-.232-3.062-1.22-.804-.757-1.745-2.103-2.469-3.313l-2.152-3.596c-1.08-1.804-2.07-3.15-2.644-3.759-.617-.655-1.41-1.446-2.675-1.446-1.024 0-1.894.718-2.621 1.818z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMetaStyleBrand__paint1_linear_3952_112970)",
    d: "M6.873 6.638c-1.024 0-1.894.718-2.622 1.818-1.029 1.553-1.659 3.866-1.659 6.088 0 .916.201 1.62.464 2.046l-2.21 1.455C.28 17.101 0 15.863 0 14.451c0-2.566.704-5.241 2.044-7.307 1.189-1.832 2.904-3.113 4.87-3.113z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandMetaStyleBrand__paint0_linear_3952_112970",
    x1: 306.75,
    x2: 1957.31,
    y1: 895.679,
    y2: 979.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandMetaStyleBrand__paint1_linear_3952_112970",
    x1: 375.573,
    x2: 375.573,
    y1: 1164.13,
    y2: 554.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandMetaStyleBrand);
export { ForwardRef as ReactComponent };